import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import brand from '../../assets/img/brand/brand-square.jpg';
import {getPath} from '../MainHeader';

const MainSidebar = ({user}) => {
  const url = window?.location?.href;

  const path = getPath(window?.location.pathname);

  useEffect(() => {
    if (document) {
      const links = Array.from(document.querySelectorAll('ul.sidebar-menu a'));

      const activeLink = links.filter(el => el.href === url)[0]?.parentElement;

      if (activeLink) {
        links.forEach(el => {
          el.parentElement.classList.remove('active');
        });
        activeLink.classList.add('active');
      }
    }
  }, [url]);

  const renderContent = () => {
    if (path === 'mpg') {
      return (
        <>
          <li
            class="header"
            style={{backgroundColor: '#04A559', color: 'white'}}>
            MPG
          </li>
          <li className="header">SUPPORT</li>
          <li>
            <Link to="/user-support">
              <i className="fa fa-address-book" /> Users
            </Link>
          </li>
          <li>
            <Link to="/league-support">
              <i className="fa fa-users" /> Leagues
            </Link>
          </li>
          <li>
            <Link to="/tournament-support">
              <i className="fa fa-trophy" /> Tournament
            </Link>
          </li>

          <li className="header">TOOLS</li>
          <li>
            <Link to="/tds?championship=1">
              <i className="fa fa-medkit" /> TDS
            </Link>
          </li>
          <li>
            <Link to="/fullPlayers">
              <i className="fa fa-address-card-o" /> Full players
            </Link>
          </li>
          <li>
            <Link to="/matches">
              <i className="fa fa-futbol-o" /> Matches
            </Link>
          </li>

          <li className="header">JERSEYS</li>
          <li>
            <Link to="/jerseys/list">
              <i className="fa fa-plus-circle" /> Add/Edit jerseys
            </Link>
          </li>
          <li>
            <Link to="/jerseys/collections?lang=fr-FR">
              <i class="fa fa-list-ul" /> Manage Collection
            </Link>
          </li>

          {/* Not displayed for now
          <li className="header">Livraison du ballon UE</li>
          <li>
            <Link to="/uber-eats/stats">
              <i className="fa fa-address-card-o" /> Stats
            </Link>
          </li>
          <li>
            <Link to="/uber-eats/game">
              <i className="fa fa-gamepad" /> Game
            </Link>
          </li>
          <li>
            <Link to="/uber-eats/winners">
              <i className="fa fa-gift" /> Winners
            </Link>
          </li>
          */}

          <li className="header">NOTIFICATIONS</li>
          <li>
            <Link to="/notifications/create">
              <i className="fa fa-plus-circle" /> Create
            </Link>
          </li>
          <li>
            <Link to="/notifications/list">
              <i class="fa fa-list-ul" /> List
            </Link>
          </li>

          <li className="header">NEWS FEED</li>
          <li>
            <Link to="/news-feed/create">
              <i className="fa fa-plus-circle" /> Create
            </Link>
          </li>
          <li>
            <Link to="/news-feed/list">
              <i class="fa fa-list-ul" /> List
            </Link>
          </li>
          <li className="header">VERSIONS</li>
          <li>
            <Link to="/version/create">
              <i className="fa fa-plus-circle" /> Create version
            </Link>
          </li>
          <li>
            <Link to="/version/list">
              <i className="fa fa-list-ul" /> List of versions 
            </Link>
          </li>
          <li>
            <Link to="/article/create">
              <i className="fa fa-plus-circle" /> Create release article 
            </Link>
          </li>
          <li>
            <Link to="/article/list">
              <i className="fa fa-list-ul" /> List of release articles
            </Link>
          </li>
          <li className="header">STATISTICS</li>
          <li>
            <Link to="/statistics/users">
              <i className="fa fa-user" /> Users
            </Link>
          </li>
          <li>
            <Link to="/statistics/leagues">
              <i className="fa fa-users" /> Leagues
            </Link>
          </li>
          <li>
            <Link to="/statistics/tournament">
              <i className="fa fa-trophy" /> Tournament
            </Link>
          </li>
          <li>
            <Link to="/statistics/business">
              <i className="fa fa-money" /> Business
            </Link>
          </li>
          <li>
            <Link to="/statistics/players">
              <i className="fa fa-address-card-o" /> Players
            </Link>
          </li>
          <li>
            <Link to="/statistics/matches">
              <i className="fa fa-futbol-o" /> Matches
            </Link>
          </li>
          <li>
            <Link to="/statistics/messaging">
              <i className="fa fa-envelope-open" /> Messaging
            </Link>
          </li>
          <li>
            <Link to="/statistics/various">
              <i className="fa fa-random" /> Various
            </Link>
          </li>
        </>
      );
    }
    if (path === 'mpp') {
      return (
        <>
          <li
            class="header"
            style={{backgroundColor: '#085EFF', color: 'white'}}>
            MPP
          </li>
          <li className="header">SUPPORT</li>
          <li>
            <Link to="/mpp/support">
              <i className="fa fa-users" /> Leagues
            </Link>
          </li>

          <li className="header">TOOLS</li>
          <li className="header">Challenge</li>
          <li>
            <Link to="/mpp/challenge">
              <i className="fa fa-plus-circle" /> Create/Edit
            </Link>
          </li>
          <li className="header">NOTIFICATIONS</li>
          <li>
            <Link to="/mpp/notification/create">
              <i className="fa fa-plus-circle" /> Create
            </Link>
          </li>
          <li>
            <Link to="/mpp/notification/list">
              <i class="fa fa-list-ul" /> List
            </Link>
          </li>
          <li>
            <Link to="/mpp/tools">International</Link>
          </li>
          <li className="header">VERSIONS</li>
          <li>
            <Link to="/mpp/version/create">
              <i className="fa fa-plus-circle" /> Create version
            </Link>
          </li>
          <li>
            <Link to="/mpp/version/list">
              <i className="fa fa-list-ul" /> List of versions 
            </Link>
          </li>
          <li>
            <Link to="/mpp/article/create">
              <i className="fa fa-plus-circle" /> Create release article 
            </Link>
          </li>
          <li>
            <Link to="/mpp/article/list">
              <i className="fa fa-list-ul" /> List of release articles
            </Link>
          </li>
          <li className="header">STATISTICS</li>
          <li>
            <Link to="/mpp/stats/leagues">
              <i className="fa fa-users" /> Leagues
            </Link>
          </li>
          <li>
            <Link to="/mpp/stats/challenges">
              <i className="fa fa-trophy" /> Challenges
            </Link>
          </li>
          <li>
            <Link to="/mpp/stats/users">
              <i className="fa fa-user" /> Users
            </Link>
          </li>
          <li>
            <Link to="/mpp/stats/messaging">
              <i className="fa fa-envelope-open" /> Messaging
            </Link>
          </li>
          <li className="header">QUESTION BONUS</li>
          <li>
            <Link to="/mpp/question-bonus/create">
              <i className="fa fa-plus-circle" /> Create Question
            </Link>
          </li>
          <li>
            <Link to="/mpp/question-bonus/list">
              <i className="fa fa-list-ul" /> List of Questions
            </Link>
          </li>
        </>
      );
    }
    if (path === 'mxi') {
      return (
        <>
          <li
            class="header"
            style={{backgroundColor: '#FF7FDE', color: 'white'}}>
            FL1
          </li>
          <li>
            <Link to="/mxi/players">
              <i className="fa fa-address-card-o" /> Players
            </Link>
          </li>
          <li>
            <Link to="/mxi/prize">
              <i className="fa fa-address-card-o" /> Prize
            </Link>
          </li>
        </>
      );
    }
  };

  return (
    <aside className="main-sidebar">
      <section className="sidebar">
        <div className="user-panel">
          <div className="pull-left image">
            <img
              src={user.avatarUrl || brand}
              className="img-circle"
              alt="User"
            />
          </div>
          <div className="pull-left info">
            <p>{user.name || 'Chèvre inconnue'}</p>
            <i className="fa fa-circle text-success" /> Online
          </div>
        </div>

        <ul className="sidebar-menu">{renderContent()}</ul>
      </section>
    </aside>
  );
};

MainSidebar.propTypes = {
  user: PropTypes.object.isRequired,
};

export default MainSidebar;



// WEBPACK FOOTER //
// ./src/components/MainSidebar/index.js